import type { WordFilters } from '../components/LearnWords/WordFilter';

const PLAYGROUND_FILTERS_KEY = 'playground-filters';
const PLAYGROUND_VIEW_MODE_KEY = 'playground-view-mode';

export function saveFilters(filters: WordFilters): void {
  try {
    localStorage.setItem(PLAYGROUND_FILTERS_KEY, JSON.stringify(filters));
  } catch (error) {
    console.warn('Failed to save filters to localStorage:', error);
  }
}

export function loadFilters(): WordFilters | null {
  try {
    const saved = localStorage.getItem(PLAYGROUND_FILTERS_KEY);
    if (!saved) return null;
    
    const parsed = JSON.parse(saved);
    // Validate the loaded data
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'confidenceLevels' in parsed &&
      'sortBy' in parsed
    ) {
      return parsed as WordFilters;
    }
    return null;
  } catch (error) {
    console.warn('Failed to load filters from localStorage:', error);
    return null;
  }
}

export function saveViewMode(viewMode: 'card' | 'list'): void {
  try {
    localStorage.setItem(PLAYGROUND_VIEW_MODE_KEY, viewMode);
  } catch (error) {
    console.warn('Failed to save view mode to localStorage:', error);
  }
}

export function loadViewMode(): 'card' | 'list' | null {
  try {
    const saved = localStorage.getItem(PLAYGROUND_VIEW_MODE_KEY);
    if (!saved) return null;

    // Validate that it's a valid view mode
    if (saved === 'card' || saved === 'list') {
      return saved;
    }
    return null;
  } catch (error) {
    console.warn('Failed to load view mode from localStorage:', error);
    return null;
  }
}

export function clearPlaygroundStorage(): void {
  try {
    localStorage.removeItem(PLAYGROUND_FILTERS_KEY);
    localStorage.removeItem(PLAYGROUND_VIEW_MODE_KEY);
  } catch (error) {
    console.warn('Failed to clear playground storage:', error);
  }
}